import { FormattedMessage } from "react-intl";
import { Grid as MuiGrid, Stack as MuiStack } from "@mui/material";

import { formatItemHtmlList } from "@framework/exchange";
import type { ITemplate } from "@framework/types";
import { Card, List, Typography } from "@dzambalaorg/ui-kit";

import { AllowanceInfoPopover } from "../../../dialogs/allowance";
import { ReferralButton, TemplatePurchaseButton } from "../../../buttons";

export interface ICommonTemplatePanelProps {
  template: ITemplate;
}

export const TemplatePanel = (props: ICommonTemplatePanelProps) => {
  const { template } = props;

  return (
    <Card sx={{ height: "fit-content", justifyContent: "flex-start" }}>
      <Card.Content>
        <MuiStack direction="row" justifyContent="space-between">
          <Typography variant="h5" component="p">
            <FormattedMessage id="pages.erc721.template.price" />
          </Typography>
          <AllowanceInfoPopover />
        </MuiStack>
        <List>{formatItemHtmlList(template.price)}</List>
      </Card.Content>
      <Card.Footer>
        <MuiGrid container alignItems="center" spacing={1}>
          <MuiGrid size={{ xs: 12 }}>
            <TemplatePurchaseButton template={template} />
          </MuiGrid>
          {!!template?.contract?.merchant?.refLevels?.length && (
            <MuiGrid size={{ xs: 12 }}>
              <ReferralButton endpoint={`/erc721/template/${template.id}`} />
            </MuiGrid>
          )}
        </MuiGrid>
      </Card.Footer>
    </Card>
  );
};
